import { render, staticRenderFns } from "./candidate-linkage-with-qbank-page-screen.html?vue&type=template&id=de3867fe&scoped=true&external"
import script from "./candidate-linkage-with-qbank-page-screen.js?vue&type=script&lang=js&external"
export * from "./candidate-linkage-with-qbank-page-screen.js?vue&type=script&lang=js&external"
import style0 from "./candidate-linkage-with-qbank-page-screen.scss?vue&type=style&index=0&id=de3867fe&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3867fe",
  null
  
)

export default component.exports